import React from 'react'
import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react"

interface SortIconProps {
  field: string
  sortField?: string
  sortDirection?: 'asc' | 'desc'
}

export function getAriaSortValue(
  field: string,
  sortField?: string,
  sortDirection?: 'asc' | 'desc'
): React.AriaAttributes['aria-sort'] {
  if (sortField !== field || !sortDirection) return 'none'
  return sortDirection === 'asc' ? 'ascending' : 'descending'
}

export function SortIcon({ field, sortField, sortDirection }: SortIconProps) {
  if (sortField !== field || !sortDirection) {
    return <ArrowUpDown className="ml-2 h-4 w-4 text-gray-400" />
  }
  return sortDirection === 'asc' ? (
    <ArrowUp className="ml-2 h-4 w-4 text-blue-600" />
  ) : (
    <ArrowDown className="ml-2 h-4 w-4 text-blue-600" />
  )
}
